var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-field',{staticClass:"field-upload"},[_c('md-file',{attrs:{"multiple":""},model:{value:(_vm.evt),callback:function ($$v) {_vm.evt=$$v},expression:"evt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }